export enum TeamMemberStatus {
  All = 'all',
  Approved = 'approved',
  Invited = 'invited',
  WaitingForApproval = 'waiting-for-approval',
  Declined = 'declined',
}
